module.exports = __webpack_public_path__ + "static/img/ST_LAWRENCE.3f4f0be.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/materials/Frendel/ST_LAWRENCE.jpg
// module id = AiNJ
// module chunks = 0